import { Box, styled, Typography } from '@mui/material'
import { FC } from 'react'
import { FlapDisplay, Presets } from 'react-split-flap-effect'

import { theme } from '@/theme/theme'

type SplitFlapTimerParams = { value: number; label?: string }

const SplitFlapTimer: FC<SplitFlapTimerParams> = ({ value, label }) => {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" gap={1} width={72}>
      <Box position={'relative'} padding={theme.spacing(0.4, 0.2)} display={'flex'} justifyContent="center">
        <StyledFlapDisplay
          chars={Presets.NUM + ',!'}
          length={Math.max(3, JSON.stringify(value).length)}
          value={JSON.stringify(value)}
        />
        <StyledBackgroundCard
          sx={{
            background: theme.palette.grey[400],
            top: 0,
          }}
        />
        <StyledBackgroundCard
          sx={{
            background: theme.palette.grey[300],
            bottom: 0,
          }}
        />
      </Box>
      <Typography fontSize={14}>{label}</Typography>
    </Box>
  )
}

const StyledFlapDisplay = styled(FlapDisplay)(() => ({
  '.styles_digit__3_I6o': {
    background: `linear-gradient(to bottom, ${theme.palette.grey[400]} 50%, ${theme.palette.grey[300]} 50%)`,
    color: theme.palette.blueDianne[900],
    fontFamily: '"Share Tech", sans-serif',
    fontWeight: theme.typography.fontWeightRegular,
    '.styles_hinge__2iwrZ': {
      background: theme.palette.grey[300],
      height: '0.04em',
      transform: 'none',
    },
  },
  background: 'transparent',
  display: 'flex',
  justifyContent: 'center',
  margin: 'auto',
  fontSize: 30,
}))

const StyledBackgroundCard = styled(Box)(() => ({
  height: '50%',
  width: '100%',
  position: 'absolute',
  borderRadius: '3px',
}))

export default SplitFlapTimer
